import { render } from "./EditButtonModal.vue?vue&type=template&id=28bbf36a&scoped=true"
import script from "./EditButtonModal.vue?vue&type=script&lang=js"
export * from "./EditButtonModal.vue?vue&type=script&lang=js"

import "./EditButtonModal.vue?vue&type=style&index=0&id=28bbf36a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bbf36a"]])

export default __exports__